import React, { Fragment } from 'react';
import { Link } from 'react-router-dom';
import { ArrowLeftIcon, ArrowRightIcon } from 'lucide-react';
interface NavItem {
  label: string;
  href: string;
}
const sections: NavItem[] = [{
  label: 'Beef',
  href: '/market-iq/beef'
}, {
  label: 'Pork',
  href: '/market-iq/pork'
}, {
  label: 'Chicken',
  href: '/market-iq/chicken'
}];
export function MarketIQNav({
  current
}: {
  current: 'beef' | 'pork' | 'chicken';
}) {
  const currentIndex = sections.findIndex(s => s.href.includes(current));
  const prev = currentIndex > 0 ? sections[currentIndex - 1] : sections[sections.length - 1];
  const next = currentIndex < sections.length - 1 ? sections[currentIndex + 1] : sections[0];
  return <div className="border-t border-gray-200 pt-8 pb-4 mb-8" data-id="element-204">
      <div className="flex items-center justify-between" data-id="element-205">
        {/* Previous */}
        <div data-id="element-206">
          {prev ? <Link to={prev.href} className="flex items-center gap-2 text-sm text-[#002f5f] hover:underline transition-colors group" data-id="element-207">
              <ArrowLeftIcon className="w-4 h-4 group-hover:-translate-x-0.5 transition-transform" data-id="element-208" />
              <span data-id="element-209">
                <span className="text-gray-400 text-xs uppercase tracking-wide block" data-id="element-210">
                  Previous
                </span>
                <span className="font-semibold" data-id="element-211">{prev.label} Dashboard</span>
              </span>
            </Link> : <div data-id="element-212" />}
        </div>

        {/* Center: All sections */}
        <div className="hidden sm:flex items-center gap-1" data-id="element-213">
          {sections.map((section, idx) => <Fragment key={section.href} data-id="element-214">
              {idx > 0 && <span className="text-gray-300 mx-1" data-id="element-215">·</span>}
              {section.href.includes(current) ? <span className="text-xs font-semibold text-gray-900 px-2 py-1 bg-gray-100 rounded" data-id="element-216">
                  {section.label}
                </span> : <Link to={section.href} className="text-xs text-[#002f5f] hover:underline px-2 py-1" data-id="element-217">
                  {section.label}
                </Link>}
            </Fragment>)}
        </div>

        {/* Next */}
        <div data-id="element-218">
          {next ? <Link to={next.href} className="flex items-center gap-2 text-sm text-[#002f5f] hover:underline transition-colors group text-right" data-id="element-219">
              <span data-id="element-220">
                <span className="text-gray-400 text-xs uppercase tracking-wide block" data-id="element-221">
                  Next
                </span>
                <span className="font-semibold" data-id="element-222">{next.label} Dashboard</span>
              </span>
              <ArrowRightIcon className="w-4 h-4 group-hover:translate-x-0.5 transition-transform" data-id="element-223" />
            </Link> : <div data-id="element-224" />}
        </div>
      </div>
    </div>;
}